export enum KeyDirection {
  UP = "up",
  DOWN = "down",
}

export interface MDSMenuInputHeaderProps {
  onChange: (value: string) => void;
  onKeyDirection?: (direction: KeyDirection) => void;
  onEscape?: () => void;
  onEnter?: () => void;
  onClear?: () => void;
  value: string;
  placeholder?: string;
}
